/**
 * Converts a floor number to its text representation
 * @param {number} floor - The floor number (0 for Ground, 1 for First, etc.)
 * @returns {string} The floor name in text format (e.g., "Ground Floor", "First Floor")
 */
const floorNumberToText = (floor) => {
  const floorWords = [
    "Ground",
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "Sixth",
    "Seventh",
    "Eighth",
    "Ninth",
    "Tenth",
    "Eleventh",
    "Twelfth",
    "Thirteenth",
    "Fourteenth",
    "Fifteenth",
    "Sixteenth",
    "Seventeenth",
    "Eighteenth",
    "Nineteenth",
    "Twentieth",
    "Twenty-First",
    "Twenty-Second",
    "Twenty-Third",
    "Twenty-Fourth",
    "Twenty-Fifth",
    "Twenty-Sixth",
    "Twenty-Seventh",
    "Twenty-Eighth",
    "Twenty-Ninth",
    "Thirtieth",
    "Thirty-First",
    "Thirty-Second",
    "Thirty-Third",
    "Thirty-Fourth",
    "Thirty-Fifth",
    "Thirty-Sixth",
    "Thirty-Seventh",
    "Thirty-Eighth",
    "Thirty-Ninth",
    "Fortieth",
    "Forty-First",
    "Forty-Second",
    "Forty-Third",
    "Forty-Fourth",
    "Forty-Fifth",
    "Forty-Sixth",
    "Forty-Seventh",
    "Forty-Eighth",
    "Forty-Ninth",
    "Fiftieth",
  ];

  if (floor >= 0 && floor <= 50) {
    return `${floorWords[floor]} Floor`;
  } else {
    return "Floor out of range";
  }
};

export default floorNumberToText;
